<div id="payment" class="registration container" *ngIf="programInfo">
    <form #paymentForm="ngForm" name="paymentForm" (ngSubmit)="forward(paymentForm)"
        novalidate autocomplete="off" appScrollToInvalid
        [ngClass]="{'form-complete': isFormCompleted}">
        <h1>{{"copy.label.PAYMENT.heading"|copy|async}}</h1>
        <div class="text-danger ms-2" *ngFor="let ccerror of CCerrors">{{ccerror}}</div>
        
        <div class="text-danger ms-2" *ngIf="hotelCardErr">{{ 'copy.html.Airfare_Costs.hotelCardErr' | copy | async}}</div>
        <!-- Hotel Guarantee -->
        <section class="card mb-3" name="hotelFee"
            *ngIf="showHotelGuarantee()">
            <app-collect-payment cardType="Hotel"
            header="copy.label.PAYMENT.FEESRT10.hotelguarantee"
            additionaltext="copy.html.HotelGuaranteeText"
             [ccOnly]="true"></app-collect-payment>
        </section>

        <div class="text-danger ms-2" *ngIf="AirCardErr">{{ 'copy.html.Airfare_Costs.AirCardErr' | copy | async}}</div>
        <!-- Air Guarantee -->
        <section class="card mb-3" name="guarantee1" 
            *ngIf="showAirfareGuarantee()">
            <app-collect-payment cardType="Air"
            header="copy.html.Airfare_Costs.title"
            additionaltext="copy.html.Airfare_Costs.additionaltext" 
            [ccOnly]="true"></app-collect-payment>
        </section>

        <div class="text-danger ms-2" *ngIf="CCollectionErr">{{ 'copy.html.CCCollection.CCollectionErr' | copy | async}}</div>
        <!-- Credit Card Collection -->
        <section class="card mb-3" name="guarantee" 
            *ngIf="showCardCollection()">
            <app-collect-payment cardType="Guarantee"
            header="copy.html.CCCollection.title"
            additionaltext="copy.html.CCCollection.additionaltext" 
            [ccOnly]="true"></app-collect-payment>
        </section>

        <div class="button_group d-flex">
          <button id="back-button" type="button" class="back btn btn-outline-primary" (click)="back()" *ngIf="!isSubmitting">
            {{ 'copy.label.GLOBAL.goback' | copy | async }}
          </button>
          <button id="forward-button" type="submit" class="inputSubmit btn btn-primary" *ngIf="!isSubmitting">
            {{ 'copy.label.GLOBAL.continue' | copy | async }}
          </button>
          <button class="inputSubmit btn btn-primary ms-auto" *ngIf="isSubmitting">
            <i class="fas fa-spinner fa-spin"></i>
          </button>
        </div>
    </form>
</div>
